import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../ressources/variables/globals';

/**
 * HTTP Interceptor qui ajoute withCredentials: true à toutes les requêtes
 * vers le backend Node.js et le site Laravel.
 * Cela permet la transmission automatique des cookies de session.
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Liste des domaines qui nécessitent withCredentials
    const credentialDomains = [
      Globals.serverEndpoint,  // Backend Node.js
      Globals.websiteRacine    // Site Laravel
    ];

    // Vérifie si la requête va vers un domaine qui nécessite credentials
    const needsCredentials = credentialDomains.some(domain => 
      request.url.startsWith(domain)
    );

    if (needsCredentials) {
      // Clone la requête avec withCredentials: true
      const modifiedRequest = request.clone({
        withCredentials: true
      });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}

